import Vue from "vue";
import VueRouter from "vue-router";
import cloudManage from "@/views/cloudInfra/cloudManage.vue"
import cloudMonitor from "@/views/cloudInfra/cloudMonitor.vue"
import awcmp from "@/views/cloudInfra/awcmp.vue"
import containerManage from "@/views/cloudInfra/containerManage.vue"
import awstack from "@/views/cloudInfra/awstack.vue"
import cloudService from "@/views/cloudService/cloudService.vue"
import aiStack from "@/views/aiInfra/aiStack.vue"
import model from "@/views/aiInfra/model.vue"
import privateClouds from "@/views/solution/privateClouds.vue"
import icCenter from "@/views/solution/icCenter.vue"
import cdd from '@/views/cdd/index.vue'
import cases from '@/views/cases/index.vue'
import caseDetail from '@/views/cases/detail.vue'
import document from '@/views/preSalesSupport/document.vue'
import consult from '@/views/preSalesSupport/consult.vue'
import company from '@/views/company/index.vue'
import desc from '@/views/company/about.vue'
import contact from '@/views/company/contact.vue'
import join from '@/views/company/join.vue'
import cooperate from '@/views/company/cooperate.vue'
import news from '@/views/news/index.vue'
import enterprise from '@/views/news/enterprise.vue'
import enterpriseDetail from '@/views/news/enterDetail.vue'
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        redirect: '/awcloud'
    },
    {
        path: '/awcloud',
        name: 'awcloud',
        component: cloudManage,
        title: 'AWCloud云计算管理平台',
    },
    {
        path: '/monitor',
        name: 'cloudMonitor',
        component: cloudMonitor,
        title: 'AWCloud监控云',
    },
    {
        path: '/awcmp',
        name: 'awcmp',
        component: awcmp,
        title: 'AWCMP多云管理平台',
    },
    {
        path: '/awcdp',
        name: 'containerManage',
        component: containerManage,
        title: 'AWCloud容器管理平台',
    },
    {
        path: '/awstack',
        name: 'awstack',
        component: awstack,
        title: 'AWSTACK超融合一体机',
    },
    {
        path: '/cloudservice',
        name: 'cloudService',
        component: cloudService,
        title: '云服务',
    },
    {
        path: '/aiStack',
        name: 'aiStack',
        component: aiStack,
        title: 'AIStack人工智能管理平台',
    },
    {
        path: '/model',
        name: 'model',
        component: model,
        title: 'AI大模型训推一体机',
    },
    {
        path: '/private_solutions',
        name: 'privateClouds',
        component: privateClouds,
        title: '私有云解决方案',
    },
    {
        path: '/ic_center',
        name: 'icCenter',
        component: icCenter,
        title: '智算中心解决方案',
    },
    {
        path: '/custom_development',
        name: 'cdd',
        component: cdd,
        title: '定制开发',
    },
    {
        path: '/cases',
        name: 'cases',
        component: cases,
        title: '案例',
    },
    {
        path: '/case_detail',
        name: 'caseDetail',
        component: caseDetail,
        title: '案例详情',
    },
    {
        path: '/document',
        name: 'document',
        component: document,
        title: '产品文档',
    },
    {
        path: '/consult',
        name: 'consult',
        component: consult,
        title: '业务咨询',
    },
    {
        path: '/about',
        name: 'company',
        component: company,
        redirect: '/about/desc', // 默认重定向到 about 子路由
        children: [
            {
                path: 'desc',
                name: 'desc',
                component: desc,
                title: '企业简介',
            },
            {
                path: 'contact',
                name: 'contact',
                component: contact,
                title: '联系我们'
            },
            {
                path: 'join',
                name: 'join',
                component: join,
                title: '加入我们'
            }
        ]
    },
    {
        path: '/cooperate',
        name: 'cooperate',
        component: cooperate,
        title: '合作伙伴',
    },
    {
        path: '/news',
        name: 'news',
        component: news,
        redirect: '/news/enterprise', // 默认重定向到 about 子路由
        children: [
            {
                path: 'enterprise',
                name: 'enterprise',
                component: enterprise,
                title: '企业新闻',
            },
            {
                path: 'enterprise/detail',
                name: 'enterpriseDetail',
                component: enterpriseDetail,
                title: '企业新闻',
            },
        ]
    },
    
]

const router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;
